import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import DrawingLogo from 'containers/Drawings/DrawingLogo';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { isEmbedded } from 'utils/mode';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import './AuctionEndSoon.css';

export default class AuctionEndSoon extends PureComponent {
  render() {
    const { post, user, onDeletePost, showLegacyFeed } = this.props;

    const message = JSON.parse(post.message);
    const { name: auctionName, auctionId, description, prizes } = message;
    const className = showLegacyFeed
      ? 'legacy-feed-auction-end-soon'
      : 'feed-auction-end-soon';

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon src={WindCreekWImage} size={30} />
          <div className="feed-message-author-container">
            <strong>An Auction ends in 5 minutes!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="auction-end-soon-container">
            {prizes && <DrawingLogo className="small" prizes={prizes} />}

            <div className="auction-end-soon-message">
              <div className="auction-end-soon-message-header">
                {auctionName}
              </div>
              <div className="auction-end-soon-message-description">
                {description}
              </div>

              {!isEmbedded() && (
                <div className="auction-end-soon-buttons">
                  <AuctionLinkButton auctionId={auctionId} />
                </div>
              )}
            </div>
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          onDeletePost={onDeletePost}
          showLegacyFeed={showLegacyFeed}
        />
      </div>
    );
  }
}

AuctionEndSoon.propTypes = {
  user: userShape,
  post: wallPostShape,
  showLegacyFeed: PropTypes.bool,
  onDeletePost: PropTypes.func
};

function AuctionLinkButton(props) {
  const to = props.auctionId ? '/auctions/' + props.auctionId : '/auctions';
  return (
    <Link
      to={to}
      className="alert-confirm btn button-color-green auction-end-soon-button"
    >
      View Now
    </Link>
  );
}
